export const API_KEY = "b2eb4160b71c4937b0d84320232009";
export const URL = "https://api.weatherapi.com/v1/forecast.json?key=";
export const TIMEOUT_SEC = 10;
export const CURRENT_W = "&days=7&aqi=yes&alerts=no";
export const SEVEN_DAY_F = "&days=7&aqi=yes&alerts=no";
export const HOURLY_LENGTH = 6;
export const WINDY_LEVEL = 19;
export const F_D_API_KEY = "&appid=620008ec95722257f62186be3bced52e";
export const F_D_API_URL = "https://api.openweathermap.org/data/2.5/forecast?q=";
// export const S_API = "http://api.weatherunlocked.com/api/forecast/";
// export const S_KEY = "?app_id=3ed297ac&app_key=74ed1138d50f76e0be473e2ab68677b2";4
export const forecast_URL =
  "https://visual-crossing-weather.p.rapidapi.com/forecast?aggregateHours=24&contentType=json&unitGroup=metric&shortColumnNames=0%location=";
export const CITY_TO_COORDS = "https://geocode.maps.co/search?q=";
export const COORDS_TO_CITY = "https://geocode.maps.co/reverse?";
export const CITIES_PER_PAGE = 5;